module.exports = __webpack_public_path__ + "static/media/promulgation-animation-main-img.28edd5a9.jpg";